<template>
  <div
    class="ist-field"
    :class="{ outlined: outlined, rounded: rounded, shimmer: loading, dense: dense }">
    <div
      class="ist-field__label"
      v-if="label && !loading">
      {{ label }}
    </div>
    <div
      class="ist-field__content"
      v-if="!loading"
      :class="{ withlabel: label }">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
  interface IstFieldProps {
    label?: string;
    outlined?: boolean;
    dense?: boolean;
    rounded?: boolean;
    loading?: boolean;
  }

  defineProps<IstFieldProps>();
</script>

<style scoped lang="scss">
  .ist-field {
    min-width: 150px;
    min-height: 56px;
    padding: 0 12px 0 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &__content {
      color: $ist-color-black;
      width: 100%;
      margin: 0 auto;
    }
    &__label {
      color: $ist-color-grey;
      padding: 5px 0 0 0;
      font-size: smaller;
    }
  }

  .dense {
    min-height: 35px;
  }

  .withlabel {
    margin: none;
    flex: 1;
  }

  .outlined {
    border: 1px solid $ist-color-grey-light;
  }

  .rounded {
    border-radius: 5px;
  }

  .shimmer {
    background: #f6f7f8;
    border: solid 1px lightgray;
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    background-size: 100%;
    display: inline-block;
    position: relative;

    animation-duration: 1s;
    animation-fill-mode: forwards;
    animation-iteration-count: infinite;
    animation-name: placeholderShimmer;
    animation-timing-function: linear;
  }

  @keyframes placeholderShimmer {
    0% {
      background-position: -468px 0;
    }

    100% {
      background-position: 468px 0;
    }
  }
</style>
